import { forwardRef, type ButtonHTMLAttributes } from 'react';

type Art = 'primaer' | 'sekundaer' | 'leise' | 'gefahr';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  art?: Art;
  laedt?: boolean;
  klein?: boolean;
  gross?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { art = 'primaer', laedt = false, klein = false, gross = false, disabled, className, children, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={['dxl-btn', `dxl-btn--${art}`, klein && 'dxl-btn--klein', gross && 'dxl-btn--gross', className].filter(Boolean).join(' ')}
      disabled={disabled || laedt}
      aria-busy={laedt || undefined}
      {...rest}
    >
      {laedt && <span className="dxl-spinner" aria-hidden />}
      {children}
    </button>
  );
});
